import { BedDouble, Bath, Users, Car, Ruler, Clock, Sparkles } from "lucide-react";

// Non-sensitive turnover brief shown to cleaners in the booking request and job view.
export default function PropertyBrief({ summary, turnover }) {
  if (!summary && !turnover) return null;
  const chips = [];
  if (summary?.bedrooms != null) chips.push({ icon: BedDouble, text: `${summary.bedrooms} bed` });
  if (summary?.bathrooms != null) chips.push({ icon: Bath, text: `${summary.bathrooms} bath` });
  if (summary?.sleeps != null) chips.push({ icon: Users, text: `Sleeps ${summary.sleeps}` });
  if (summary?.size_approx) chips.push({ icon: Ruler, text: summary.size_approx });
  if (summary?.parking_info) chips.push({ icon: Car, text: summary.parking_info });
  if (summary?.estimated_duration_hours) chips.push({ icon: Clock, text: `Est. ${summary.estimated_duration_hours}h` });
  else if (turnover?.estimated_duration_hours) chips.push({ icon: Clock, text: `Est. ${turnover.estimated_duration_hours}h` });

  const flags = [
    turnover?.linen_change && "Linen change",
    turnover?.towels_replace && "Towels to replace",
    turnover?.restock_consumables && "Restock consumables",
    turnover?.same_day_turnaround && "Same-day turnaround",
  ].filter(Boolean);

  return (
    <div className="mt-3 p-4 rounded-xl bg-secondary/50 border border-border" data-testid="property-brief">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <Sparkles className="h-4 w-4 text-accent" />
        {summary?.name ? `Turnover · ${summary.name}` : "Holiday let turnover"}
      </div>
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2.5">
          {chips.map((c, i) => (
            <span key={i} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background border border-border text-xs">
              <c.icon className="h-3.5 w-3.5 text-accent" /> {c.text}
            </span>
          ))}
        </div>
      )}
      {flags.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {flags.map((f) => (
            <span key={f} className="px-2.5 py-1 rounded-full bg-accent/10 text-accent text-xs font-medium">{f}</span>
          ))}
        </div>
      )}
      {turnover?.checkin_deadline && (
        <p className="text-sm mt-2.5"><span className="text-muted-foreground">Guest-ready by:</span> <strong>{turnover.checkin_deadline}</strong></p>
      )}
      {turnover?.cleaning_instructions && <p className="text-sm mt-2 italic">"{turnover.cleaning_instructions}"</p>}
      {summary?.cleaner_notes && <p className="text-sm mt-2 text-muted-foreground">{summary.cleaner_notes}</p>}
      <p className="text-xs text-muted-foreground mt-3">Entry and alarm details are shared privately once you accept.</p>
    </div>
  );
}
